var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-4 pb-12 sm:px-4 lg:px-8"},[_c('div',{staticClass:"my-8 rounded-lg bg-white p-6"},[_c('editOfficeForm',{attrs:{"title":"Edit Data Kantor Pelayanan","view-as":"kantor_pelayanan"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }